class ComponentsSelectizeCtrl {
    constructor($element, $scope) {
        this.element = $element;
        this.scope = $scope;

        this.selectizeSetStarted = false;

        this.scope.$watch(
            () => this.ngDisabled,
            disable => {
                if (this.ngDisabled) {
                    this.selectizeInstance.disable();
                    return;
                }

                return this.selectizeInstance.enable()
            });
    }

    $onInit() {
        this.maxItems = !_.isUndefined(this.maxItems) ? this.maxItems : 1;
        if (this.ngModel === undefined) {
            this.ngModel = this.maxItems > 1 ? [] : '';
        }

        const options = _.defaults(this.selectizeOptions, {
            maxItems: this.maxItems,
            options: this.items || [],
            delimiter: '##--..--##',
            placeholder: (this.maxItems !== 1) ? 'Select one or more' : 'Select one',
            valueField: 'value',
            labelField: 'label',
            searchField: 'label',
            sortField: 'label'
        });

        this.selectizeInstance = this.element.find('select').selectize(options)[0].selectize;

        this.selectizeInstance.setValue(this.ngModel);

        setTimeout(() => {
            this.scope.$watch(() => this.items, (items, old) => {
                if (!_.isEqual(items, old)) {
                    this.selectizeInstance.clearOptions();
                    this.selectizeInstance.addOption(items);
                    this.selectizeInstance.setValue(this.ngModel);
                }
            });

            this.selectizeInstance.on('change', (val) => {
                if (!_.isEqual(this.ngModel, val)) {
                    this.ngModel = val;
                    this.onChange({model: val});
                    this.scope.$applyAsync();
                }
            });
        }, 200)


    }
}

angular
    .module('festzelt-os.components')
    .controller('ComponentsSelectizeController', [
        '$element',
        '$scope',
        ComponentsSelectizeCtrl
    ]);



// WEBPACK FOOTER //
// ./src/app/components/components/selectize/controller.js